module.exports = __webpack_public_path__ + "img/12.ec7d6c38.png";